import {useEffect, useState} from 'react';
import {useAchievements} from '../api';
import {type IUserAchievement} from '../../api/achievements';

interface IUseHandleAchievementsType {
    displayNotification: boolean;
    lastEarnedAchievement: IUserAchievement & { name: string, details: string, } | null;
    setDisplayNotification: (v: boolean) => void;
}

const displayThreshold = 1000 * 60 * 2; // 2 minutes

export const useHandleAchievements = () :IUseHandleAchievementsType => {

    const [lastEarnedAchievement, setLastEarnedAchievement] = useState<IUseHandleAchievementsType['lastEarnedAchievement']>(null);
    const [displayNotification, setDisplayNotification] = useState(false);
    const { data: achievementsData } = useAchievements();


    useEffect(() => {
        if (lastEarnedAchievement && lastEarnedAchievement.earned_at) {
            const fromNowToEarned = new Date().getTime() - new Date(lastEarnedAchievement.earned_at).getTime();
            if (fromNowToEarned > displayThreshold) { return; } // Don't show if earned too long ago

            setDisplayNotification(true);

            const timeoutId = setTimeout(() => {
                setDisplayNotification(false);
            }, 5000); // Hide after 5 seconds

            return () => clearTimeout(timeoutId);
        }
    }, [lastEarnedAchievement]);

    useEffect(() => {
        if (!achievementsData?.achievements || !achievementsData.user_achievements.length) { return; }
        if (!achievementsData?.user_achievements || !achievementsData.user_achievements.length) { return; }

        const sortedAchievements = achievementsData.user_achievements
            .filter((a: any) => !!a.earned_at)
            .sort(
                (a: any, b: any) => new Date(b.earned_at!).getTime() - new Date(a.earned_at!).getTime()
            );


        const lastAchievement = sortedAchievements[0];

        if (!lastAchievement) { return; }

        const achievement = achievementsData.achievements.find((a: any) => a.id === lastAchievement.achievement_id);
        setLastEarnedAchievement({ ...lastAchievement, name: achievement?.name || '', details: achievement?.details || '' });
    }, [achievementsData, setLastEarnedAchievement]);
    return {
        displayNotification,
        lastEarnedAchievement,
        setDisplayNotification
    };
};
